import { compose } from 'recompose';

import LabelPriorityTask from './labelPriorityTask';

const enhance = compose();
export default enhance(LabelPriorityTask);
